module.exports = __webpack_public_path__ + "img/99.4bccf389.jpg";